<template>
  <div class="website">
    <div v-if="!isMobile" class="web">
      <p class="m-0 Txt-title">Conference & Workshop</p>
      <div class="mt-70 newsCard">
        <div class="newsCard__sortText">
          <div class="mr-35 mb-15" v-for="(item, index) in websiteSort" :key="'NS__' + index">
            <a class="d-flex align-items-center justify-content-end flex-row text-decoration-none" :href="item.path" target="_blank" v-if="item.path">
              <p class="m-0">{{ item.pathName }}</p>
              <i class="el-icon-minus"></i>
              <p class="m-0">0{{ index + 1 }}</p>
            </a>
            <router-link class="d-flex align-items-center justify-content-end flex-row text-decoration-none" :class="{ active: $route.name == item.pathURL }" :to="{ name: item.pathURL }" v-else>
              <p class="m-0">{{ item.pathName }}</p>
              <i class="el-icon-minus"></i>
              <p class="m-0">0{{ index + 1 }}</p>
            </router-link>
          </div>
        </div>

        <LoadShowIMG />

        <div class="w-100 newsCard__title">
          <div class="px-60 py-40">
            <div class="w-100 d-flex flex-row">
              <div class="w-100">
                <p class="m-0">{{ getPathName(websiteSort) }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="w-100">
          <router-view></router-view>
        </div>
      </div>
    </div>

    <div v-else class="phone pt-70">
      <PhoneTitle :title="getPathName(websiteSort)" :filterDate="false" />
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import LoadShowIMG from "@/components/LoadShowIMG.vue";
import PhoneTitle from "@/components/PhoneTitle.vue";

export default {
  components: {
    LoadShowIMG,
    PhoneTitle,
  },
  data() {
    return {
      isMobile: false,
      websiteSort: [
        {
          pathURL: "workCamp",
          pathName: "工作營",
        },
        {
          // path: "https://crafts.ntua.edu.tw/CDC2009/main.php",
          pathURL: "seminar",
          pathName: "研討會",
        },
      ],
    };
  },
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  },
  computed: {
    getPathName() {
      return (data) => {
        let pName = "";
        data.forEach((item) => {
          if (this.$route.name == item.pathURL) {
            pName = item.pathName;
          }
        });
        return pName;
      };
    },
    getYearGrouop() {
      return () => {
        const YY = new Date().getFullYear();
        let countYear = [];
        for (let i = YY - 5; i <= YY; i++) {
          countYear.push(i);
        }
        countYear.reverse();
        return countYear;
      };
    },
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth < 1280;
    },
  },
};
</script>

<style lang="scss">
.website {
  .web {
    padding-top: 420px;
    margin-left: 120px;

    .Txt-title {
      font-size: 48px;
      line-height: 56px;
      color: #596164;
    }

    .newsCard {
      background-color: white;
      margin-bottom: 90px;
      &__sortText {
        position: absolute;
        right: 0;
        z-index: 10;
        margin-top: 45px;
        a {
          font-weight: 400;
          font-size: 24px;
          line-height: 210%;
          letter-spacing: 0.25em;
          color: #52505a;
          cursor: pointer;
          &:hover {
            color: #563f05;
            font-weight: bold;
          }
        }
      }
      .active {
        color: #563f05;
        font-weight: bold;
      }
      &__title {
        p {
          font-size: 64px;
          line-height: 75px;
          color: #ceb87f;
        }
        &_chooseYear {
          select {
            width: 150px;
            height: 35px;
            border: 0;
            border-radius: 15px;
            background: #ceb87f;
            text-align-last: center;
            font-size: 18px;
            line-height: 21px;
            color: #52505a;
            cursor: pointer;
          }
        }
      }
      &-contentCard {
        background: #2d2d2d;
        padding: 130px 220px 50px 60px;
        &_title {
          width: 100%;
          padding: 40px 30px;
          background: #c4c4c4;
        }
      }
    }
  }
}
</style>